import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllUsers = (params) => {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.page) queryParams.append("page", params.page);
  const finalUrl = queryParams.toString()
    ? `${endPoints.getAllUsers}?${queryParams.toString()}`
    : `${endPoints.getAllUsers}`

    console.log(finalUrl,"dsadsaduisaduisadusaduiasdiusadiusa");

  return Api(finalUrl, null, requestType.GET);
};

const updateUser = (id, params) => {
  return Api(`${endPoints.updateUser}/${id}`, params, requestType.PUT);
};

const blockUserStatus = (id, params) => {
  return Api(`${endPoints.blockUserStatus}/${id}`, params, requestType.PUT);
};

const getUserWithdrawRequest = () => {
  return Api(`${endPoints.userWithdrawRequest}`, null, requestType.GET);
};

const updateUserWithdrawRequest = (id, payload) => {
  return Api(
    `${endPoints.userWithdrawRequest}/${id}`,
    payload,
    requestType.PUT
  );
};

export {
  getAllUsers,
  updateUser,
  blockUserStatus,
  getUserWithdrawRequest,
  updateUserWithdrawRequest,
};
